import { ModalNames } from "~/jsx/context/ModalNames";
import { XDesignModal } from "../design/XDesignModal";
import { XButton, XPackBy, XTechTile } from "../design";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";

export const XTechModal = () => {
  const { techTiles } = useViewingPlayerOpt() ?? {};
  const { onUseTech } = useActions();
  if (!techTiles) return null;
  return (
    <XDesignModal name={ModalNames.tech} title="Use a tech">
      <XPackBy packSize={5} gap={5}>
        {techTiles.pile.map((tech) => (
          <XButton key={tech.id} onClick={onUseTech(tech)}>
            <XTechTile techTile={tech} />
          </XButton>
        ))}
      </XPackBy>
    </XDesignModal>
  );
};
